import { defineMessages } from 'react-intl';

export const validationMessages = defineMessages({
    validate: {
        id: 'validate',
        defaultMessage: 'Validate',
    },
    validateStay: {
        id: 'validate-stay',
        defaultMessage: 'Validate stay',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    stayValidated: {
        id: 'stay-validated',
        defaultMessage: 'Stay validated',
    },
    stayValidatedDescription: {
        id: 'stay-validated-description',
        defaultMessage: 'The stay was successfully validated',
    },
    validations: {
        id: 'validations',
        defaultMessage: 'Validations',
    },
    validation: {
        id: 'validation',
        defaultMessage: 'Validation',
    },
    activeStayPeriod: {
        id: 'active-stay-period',
        defaultMessage: 'Active stay period',
    },
    pastStayPeriod: {
        id: 'past-stay-period',
        defaultMessage: 'Past stay period',
    },
    visitor: {
        id: 'visitor',
        defaultMessage: 'Visitor',
    },
    search: {
        id: 'search',
        defaultMessage: 'Search',
    },
    pastValidations: {
        id: 'past-validations',
        defaultMessage: 'Past validations',
    },
    validatedAmount: {
        id: 'validated-amount',
        defaultMessage: 'Validated amount',
    },
    validatedTime: {
        id: 'validated-time',
        defaultMessage: 'Validated time',
    },
    validationCombinedError: {
        id: 'custom-error:validation_cannot_be_combined',
        defaultMessage: 'The validation cannot be combined as the type does not allow it!',
    },
    validationMultipleTypesError: {
        id: 'custom-error:multiple_validation_types_per_active_stay',
        defaultMessage: 'Only one validation type can be present for an active stay!',
    },
    validationMultipleGuestTypesError: {
        id: 'custom-error:multiple_validations_of_guest_type',
        defaultMessage: 'Only one validation of guest type can be present per active stay period!',
    },
});
